import { employeeTypeActionSelectors as selector } from "../Selectors/index";

export const employeeTypeReducer = (state = [], { type, payload }) => {
  switch (type) {
    case selector.GET:
      return payload;

    default:
      return state;
  }
};
